import { Modal, Input, Button } from "antd";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactModal.css";

const ContactModal = ({ visible, onCancel }) => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setSent(true);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <Modal
      className="contact-modal"
      onCancel={onCancel}
      open={visible}
      width="35vw"
      centered
      style={{ minWidth: 300 }}
      zIndex={1000}
      footer={null}
      destroyOnHidden
    >
      {sent ? (
        <div className="contact-success">
          <h2>Message sent!</h2>
          <p>I’ll get back to you soon.</p>
          <Button style={{ background: "var(--primary-color)" }} onClick={onCancel}>
            Ok!
          </Button>
        </div>
      ) : (
        <form ref={formRef} onSubmit={sendEmail} className="contact-form">
          <h2>Let’s chat ✨</h2>
          <p className="subtitle">Drop me a little note below</p>

          <Input
            name="name"
            placeholder="Your name"
            required
          />

          <Input
            name="email"
            type="email"
            placeholder="Your email"
            required
          />

          <Input.TextArea
            name="message"
            rows={4}
            placeholder="Your message"
            required
          />

          <Button
            htmlType="submit"
            style={{ backgroundColor: "var(--primary-color)" }}
            loading={loading}
            block
          >
            Send
          </Button>
        </form>
      )}
    </Modal>
  );
};

export default ContactModal;
